module.exports = __webpack_public_path__ + "static/img/promo_leaf_bg.e4bcbf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promo_leaf_bg.png
// module id = T3sw
// module chunks = 0